import { loginRadiusStore } from "@/store/loginRadiusStore";
import type { LoginRadiusConfig, LoginRadiusModule } from "@/ts/module";
import type { Exactly } from "@/ts/types";
const ready = async (maxWait: number): Promise<boolean> => {
    let waitingTimeRemaining: number = maxWait;
    return new Promise((resolve) => {
        const checkConditions = () => {
            if (window.login_radius_user_profile) {
                resolve(true);
            }
            else {
                waitingTimeRemaining -= 100;
                if (waitingTimeRemaining <= 0) {
                    resolve(true);
                }
                setTimeout(checkConditions, 100);
            }
        };
        checkConditions();
    });
};
const getEmailFromWindow = (): string | undefined => {
    return window?.login_radius_user_profile?.Email?.[0]?.Value || undefined;
};
const getEmailFromApi = async (apiKey: string): Promise<string | undefined> => {
    const sessionToken = window.localStorage.getItem("loginRadiusToken");
    if (!(apiKey && sessionToken)) {
        return undefined;
    }
    const response = await fetch(`https://api.loginradius.com/identity/v2/auth/account?apikey=${apiKey}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${sessionToken}`,
            "Content-Type": "application/json",
        },
    });
    const data = await response.json();
    if (data?.Email?.Value?.length === 0) {
        return undefined;
    }
    return data?.Email?.[0]?.Value || undefined;
};
const getEmail = async (apiKey: string): Promise<string | undefined> => {
    const emailFromWindow = getEmailFromWindow();
    if (emailFromWindow) {
        return emailFromWindow;
    }
    const emailFromApi = await getEmailFromApi(apiKey);
    return emailFromApi || undefined;
};
export class LoginRadius implements Exactly<LoginRadiusModule, LoginRadius> {
    private config: LoginRadiusConfig;
    name = "LoginRadius" as const;
    constructor(config: LoginRadiusConfig) {
        this.config = config;
    }
    async init(): Promise<void> {
        await ready(this.config.readyTimeout);
        const email = await getEmail(this.config.apiKey);
        if (email) {
            loginRadiusStore.setState({ email });
        }
    }
}
